<template>
  <div id="LuckyDraw" v-if='notips'>
    <div v-if="showDrawPop">

      <!--遮罩层-->

      <div class="lucky-draw">

        <div class="lucky-rw">
          <div class="lucky-date"> 任务已完成</div>
          <div class="goDucky" @click.stop="goDraw()">去抽奖></div>
        </div>
        <div class="lucky-draw-close-icon" @click.stop="luckyDrawClose()">
          <img :src="modelImg" alt="">
        </div>
        <label class="checkLabel">
          <div style='text-decoration:underline;display:inline-block;' @click='clickNoTips()'>
            不再提示
          </div>

        </label>
      </div>

    </div>
  </div>
</template>

<script>
  import {
    getUserId
  } from "@/utils/methods.js";
  import Cookie from 'js-cookie'
  import {
    addWebApiChoice,
    getWebApiActivityInfo,
    getWebApiLottery
  } from "@/api/luck.js";

  export default {
    name: "LuckyDraw",
    computed: {
      // 播放器对象
      player_cpu() {
        return this.$store.state.player;
      }
    },
    data() {
      return {
        playerTime: 0,
        playerInterval: null, // 获取播放时间的循环函数
        hasCertificate: false,
        ocs_muke_time: 0, // 播放时长
        showDrawPop: false, //控制弹窗是否显示
        param: '2', //设置默认值为1，即设置第一个单选框为选中状态
        modelImg: require("@/assets/img/luckyCloseIcon.png"),
        giftChoiceForCourse: true,
        id: '',
        notips: false,
        openActive: false, //活动是否开启
        endTimeS: '',
        closeTime: true
      }
    },
    methods: {

      // 获取播放时间
      playerTime_get(player) {
        //console.log(1)
        // 点击播放按钮事件
        if (!this.activity) {
          const userId = getUserId(false)
          if (userId) {
            player.on('play', () => {
              // 只有第一次点击播放的时候才加一
              // if (this.lock_once) {
              //   this.lock_once = false;

              // }
              localStorage.setItem('ocs_luckydraw' + userId, ++this.ocs_muke_time);
              clearInterval(this.playerInterval)
              this.playerInterval = setInterval(() => {
                ++this.playerTime;
              }, 1000)
              //console.log(this.playerTime, "sss")
            })
            // 播放器暂停
            player.on('pause', () => {
              clearInterval(this.playerInterval)
            })
          }
        }
      },
      countDown_get(n) {
        // console.log("1", this.playerTime,this.giftChoiceForCourse)
        const hasPlayTime = localStorage.getItem('timeDisplayYun')
        var newPlayTime = 0
          if (!this.giftChoiceForCourse) {
            if (this.playerTime == 60) {
               this.getWebApiLottery()
              if (hasPlayTime&&this.closeTime) {
                newPlayTime = parseInt(hasPlayTime) + 60
                localStorage.setItem('timeDisplayYun', newPlayTime)
                if (newPlayTime >= 300) {
                  //console.log(localStorage.getItem('luckyDrawPopClose') !== '1')
                  //console.log(localStorage.getItem('luckyDrawPopClose'), "localStorage.getItem('luckyDrawPopClose') ")
                  if (localStorage.getItem('luckyDrawPopClose') !== '1' || localStorage.getItem('luckyDrawPopClose') ==
                    undefined) {
                    //  时间>300s显示弹窗
                    this.showDrawPop = true
                    this.notips = true
                    setTimeout(() => {
                      this.showDrawPop = false
                      this.notips = false
                    }, 10000)
                    //console.log(this.newPlayTime, "newPlayTime")
                  }
                  this.addChoice()
                  this.getWebApiActivityInfo()
                }


              } else {
                 if (this.closeTime){ localStorage.setItem('timeDisplayYun', this.playerTime)}
               
              }
            }

            if (this.playerTime == 120) {
              this.getWebApiLottery()
              if (hasPlayTime&&this.closeTime) {
                newPlayTime = parseInt(hasPlayTime) + 60
                localStorage.setItem('timeDisplayYun', newPlayTime)
                if (newPlayTime >= 300) {
                  if (localStorage.getItem('luckyDrawPopClose') !== '1' || localStorage.getItem('luckyDrawPopClose') ==
                    undefined) {
                    //  时间>300s显示弹窗
                    this.showDrawPop = true
                    this.notips = true
                    setTimeout(() => {
                      this.showDrawPop = false
                      this.notips = false
                    }, 10000)
                    //console.log(this.newPlayTime, "newPlayTime")
                  }
                  this.addChoice()
                  this.getWebApiActivityInfo()
                }

              } else {
                     if (this.closeTime){ localStorage.setItem('timeDisplayYun', this.playerTime)}
              }
            }


            if (this.playerTime == 180) {
              this.getWebApiLottery()
              if (hasPlayTime&&this.closeTime) {
                newPlayTime = parseInt(hasPlayTime) + 60
                localStorage.setItem('timeDisplayYun', newPlayTime)
                if (newPlayTime >= 300) {
                  if (localStorage.getItem('luckyDrawPopClose') !== '1' || localStorage.getItem('luckyDrawPopClose') ==
                    undefined) {
                    //  时间>300s显示弹窗
                    this.showDrawPop = true
                    this.notips = true
                    setTimeout(() => {
                      this.showDrawPop = false
                      this.notips = false
                    }, 10000)
                    //console.log(this.newPlayTime, "newPlayTime")
                  }
                  this.addChoice()
                  this.getWebApiActivityInfo()
                }

              } else {
                   if (this.closeTime){ localStorage.setItem('timeDisplayYun', this.playerTime)}
              }
            }

            if (this.playerTime == 240) {
              this.getWebApiLottery()
              if (hasPlayTime&&this.closeTime) {
                newPlayTime = parseInt(hasPlayTime) + 60
                localStorage.setItem('timeDisplayYun', newPlayTime)
                if (newPlayTime >= 300) {
                  if (localStorage.getItem('luckyDrawPopClose') !== '1' || localStorage.getItem('luckyDrawPopClose') ==
                    undefined) {
                    //  时间>300s显示弹窗
                    this.showDrawPop = true
                    this.notips = true
                    setTimeout(() => {
                      this.showDrawPop = false
                      this.notips = false
                    }, 10000)
                    //console.log(this.newPlayTime, "newPlayTime")
                  }
                  this.addChoice()
                  this.getWebApiActivityInfo()
                }

              } else {
                     if (this.closeTime){ localStorage.setItem('timeDisplayYun', this.playerTime)}
              }
            }

            if (this.playerTime == 300) {
               this.getWebApiLottery()
              if (hasPlayTime&&this.closeTime) {
                newPlayTime = parseInt(hasPlayTime) + 60
                localStorage.setItem('timeDisplayYun', newPlayTime)
                if (newPlayTime >= 300) {
                  if (localStorage.getItem('luckyDrawPopClose') !== '1' || localStorage.getItem('luckyDrawPopClose') ==
                    undefined) {
                    //  时间>300s显示弹窗
                    this.showDrawPop = true
                    this.notips = true
                    setTimeout(() => {
                      this.showDrawPop = false
                      this.notips = false
                    }, 10000)
                    //console.log(this.newPlayTime, "newPlayTime")
                  }
                  this.addChoice()
                  this.getWebApiActivityInfo()
                }


              } else {
                this.getWebApiLottery()
                 if (this.closeTime) {
                localStorage.setItem('timeDisplayYun', this.playerTime)
                this.showDrawPop = true
                this.notips = true
                setTimeout(() => {
                  this.showDrawPop = false
                  this.notips = false
                }, 10000)
                this.addChoice()
                this.getWebApiActivityInfo()
                 }
              }
            }

          }
     


      },




      addChoice() {
        // 如果有云课堂的领取权限 就访问接口增加次数
        if (!this.giftChoiceForCourse && this.openActive) {
          this.addWebApiChoice()
        }
      },


      // 关闭弹窗部分
      luckyDrawClose() {
        this.showDrawPop = false
        // localStorage.setItem('luckyDrawPopClose', this.param)
      },

      //  点击跳转到抽奖页面
      goDraw() {
        // localStorage.setItem('luckyDrawPopClose', this.param)
        location.href = '/luckydraw'
      },

      // 点击不再提示
      clickNoTips() {
        this.param = '2'
        this.showDrawPop = false
        //console.log(this.param, "params")
        localStorage.setItem('luckyDrawPopClose', this.param)
      },

      // 是否显示抽奖弹窗
      showLuckyPop() {
        // this.notips = true
        // localStorage.setItem('luckyDrawPopClose', 2)
        var showLuckyPopNum = localStorage.getItem('luckyDrawPopClose')
        //console.log(showLuckyPopNum, "showLuckyPopNum")
        if (showLuckyPopNum) {
          //console.log(showLuckyPopNum, "showLuckyPopNum")
          if (showLuckyPopNum == '1') {
            // this.notips = true
            this.param = '1'
          } else {
            // this.notips = false
            this.param = '2'
            // localStorage.setItem('luckyDrawPopClose', this.param)
          }
        } else {
          // this.showDrawPop = true
        }
        //console.log(showLuckyPopNum, "showLuckyPopNum")
      },

      // 增加抽奖次数
      addWebApiChoice() {
        const userId = Cookie.get('medtion_member_id')
        if (!userId) {
          return
        }
        // 发请求
        addWebApiChoice({
          activityId: this.id,
          source: 'watchCourse',
          userId: userId,
          num: 1
        }).then((res) => {
          //console.log(res, "res", res.result)

        })
      },


      // 获取用户详情
      getWebApiActivityInfo() {
        const userId = Cookie.get('medtion_member_id')
        if (!userId) {
          return
        }
        // 发请求
        getWebApiActivityInfo({
          activityCode: '948afa8e733347ad962b655dbc4501b9',
          userId: userId,
        }).then((res) => {
          // this.activityId = res.result.id
          // console.log(res.data,res.data.data.giftChoiceForCourse, "getWebApiActivityInfo")
          this.giftChoiceForCourse = res.data.giftChoiceForCourse
        })

      },

      FormatDate(strTime) {
        var date = new Date(strTime);
        return date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + date.getDate() + " " + date.getHours() + ":" +
          date.getMinutes() + ":" +date.getSeconds();
      },

      // 是否开启关闭活动
      getWebApiLottery() {
        // 发请求
        getWebApiLottery({
          activityCode: '948afa8e733347ad962b655dbc4501b9'
        }).then((res) => {
          //console.log(res, "res开启关闭", res.data.result)
          this.id = res.data.result.id
          this.endTimeS = res.data.result.endTime
          var startTimeClose = res.data.result.startTime
          var today = new Date();
          var today_time = this.FormatDate(today);
          // console.log(today_time, this.endTimeS, 'this.endTimeS')
           if(new Date(today_time).getTime()>new Date(this.endTimeS)||new Date(today_time).getTime()<new Date(startTimeClose).getTime()){
          this.closeTime=false
        }
          if (res.data.result.status == 'O') {
            //console.log('开启')
            if (!this.closeTime) {
              this.openActive = false
              this.showDrawPop = false
            } else {
              // this.$toast('活动有效')
              this.showDrawPop = true
              this.openActive = true
            }
            // this.param = '2'
            // localStorage.setItem('luckyDrawPopClose', 2)
          } else {
            //console.log('关闭')
            this.openActive = false
            this.showDrawPop = false
            this.param = '1'
            localStorage.setItem('luckyDrawPopClose', 1)
          }
          // console.log('-----',this.openActive)
        })
      },

      //  获取当时日期不对就去除记录
      getNowDate() {
        const timeOne = new Date()
        const year = timeOne.getFullYear()
        let month = timeOne.getMonth() + 1
        let day = timeOne.getDate()
        month = month < 10 ? '0' + month : month
        day = day < 10 ? '0' + day : day
        const NOW_MONTHS_AGO = `${year}年${month}月${day}日`
        //console.log(NOW_MONTHS_AGO, "NOW_MONTHS_AGO")

        var recodeDateTime = localStorage.getItem("recodeDateTime")
        //console.log(recodeDateTime, "recodeDateTime")
        if (recodeDateTime) {
          if (recodeDateTime !== NOW_MONTHS_AGO) {
            //console.log("时间不等")
            localStorage.removeItem("timeDisplayYun")
            localStorage.removeItem("localArticleRecode")
            localStorage.removeItem("timeDisplay")
            localStorage.setItem("recodeDateTime", NOW_MONTHS_AGO)
          }
        } else {
          localStorage.setItem("recodeDateTime", NOW_MONTHS_AGO)
        }

      },


    },
    mounted() {
      this.getWebApiLottery()
      // this.addWebApiChoice()
      //  判断用户是否领取云课堂时长奖励
      this.getWebApiActivityInfo()


      // 判断用户是否点击不再提示
      this.showLuckyPop()

      this.getNowDate()
      //  var timeDisplayShow = localStorage.getItem("timeDisplayYun")
      // if (localStorage.getItem('luckyDrawPopClose') !== '2') {
      //   if (timeDisplayShow && parseInt(timeDisplayShow) >= 300) {
      //     this.showDrawPop = true
      //     this.notips = true
      //     setTimeout(() => {
      //       this.showDrawPop = false
      //       this.notips = false
      //     }, 10000)
      //   }
      // }


    },
    watch: {
      player_cpu: {
        handler(n) {
          this.playerTime_get(n);
        }
      },
      playerTime: {
        handler(n) {
          this.countDown_get(n);
        }
      }
    },
    onUnmounted() {
      clearInterval(this.playerInterval);
    },
  }
</script>

<style scoped lang="scss">
  .lucky-draw {
    z-index: 3000;
    position: fixed;
    right: 43%;
    transform: translateX(50%);
    bottom: 30%;
    width: 128px;
    height: 30px;
    color: #789db4;
    background: rgba(255, 238, 213, 0.65);
    box-shadow: inset 0px -2px 2px rgb(255 255 255 / 39%);
    border-radius: 10px;
    box-sizing: border-box;
    background-size: 100% 100%;

    img {
      width: 100%;
      height: 100%;
    }
  }

  .lucky-draw-mask {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 2009;
    width: 100%;
    height: 100%;
    background-color: #333;
    opacity: 0.51;
    overflow: hidden;
  }

  .lucky-draw-close-icon {
    position: relative;
    bottom: 130%;
    left: 0%;
    right: 36px;
    float: right;
    width: 16px;
    height: 16px;

    img {
      width: 100%;
      height: 100%;
    }
  }

  .lucky-go-draw {
    color: #FFF0E2;
    width: 200px;
    height: 58px;
    line-height: 58px;
    text-align: center;
    position: absolute;
    bottom: 0;
    left: 50%;
    -webkit-transform: translateX(-50%);
    transform: translateX(-50%);
    right: 36px;
    float: right;
    background: -webkit-gradient(linear, left top, left bottom, from(#F35735), to(#DB320D));
    background: -webkit-linear-gradient(top, #F35735 0%, #DB320D 100%);
    background: linear-gradient(180deg, #F35735 0%, #DB320D 100%);
    border-radius: 60px;
  }

  .lucky-date {
    display: flex;
    -webkit-box-pack: center;
    -webkit-justify-content: center;
    -moz-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    /* position: relative; */
    /* top: 33%; */
    color: #BF6213;
    font-size: 10px;
  }


  .checkLabel {
    font-size: 8px;
    cursor: pointer;
    position: relative;
    bottom: 9%;
    left: 39%;
    color: #DF8924;
  }

  .checkLabel i {
    font-size: 12px;
    font-style: normal;
    display: inline-block;
    width: 12px;
    height: 12px;
    text-align: center;
    line-height: 12px;
    color: rgba(255, 255, 255, 0);
    vertical-align: middle;
    margin: -2px 2px 1px 0px;
    border: #DF8924 1px solid;
    border-radius: 50%;
  }

  .checkLabel input[type="checkbox"],
  input[type="radio"] {
    display: none;
  }

  .checkLabel input[type="checkbox"]:checked+i,
  input[type="radio"]:checked+i {
    background: #DF8924;
    ;
    color: rgba(255, 255, 255, 1);
  }

  .checkLabel input[type="checkbox"]:disabled+i,
  input[type="radio"]:disabled+i {
    border-color: #DF8924;
    ;
  }

  .checkLabel input[type="checkbox"]:checked:disabled+i,
  input[type="radio"]:checked:disabled+i {
    background: #DF8924;
    ;
  }

  .noselect {
    -webkit-touch-callout: none;
    /* iOS Safari */
    -webkit-user-select: none;
    /* Chrome/Safari/Opera */
    -khtml-user-select: none;
    /* Konqueror */
    -moz-user-select: none;
    /* Firefox */
    -ms-user-select: none;
    /* Internet Explorer/Edge */
    user-select: none;
    /* Non-prefixed version, currently not supported by any browser */
  }

  .suspensionBox {
    z-index: 3000;
    position: fixed;
    right: 5%;
    /* left: 0; */
    top: 26%;
    -webkit-transform: translateX(50%);
    transform: translateX(50%);
    width: 80px;
    height: 80px;
    color: #789db4;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    background-size: 100% 100%;

    img {
      width: 100%;
      height: 100%;
    }
  }

  .lucky-rw {
    width: 128px;
    height: 30px;
    display: -webkit-box;
    display: -webkit-flex;
    display: -moz-box;
    display: -ms-flexbox;
    display: flex;
    font-size: 10px;
    justify-content: center;
    align-items: center;
  }

  .goDucky {
    font-weight: 600;
    font-size: 13px;
    color: #ac3007;
    padding-left: 5px;
    cursor: pointer
  }
</style>